/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */
import type {
  AccountPaymentPlan,
  CancelPaymentPlanParams,
  CancelPaymentPlanRequest,
  CreatePaymentPlanRequest,
  GetPaymentPlanOptionsByAccountIdParams,
  GetPaymentPlanOptionsResponse,
  GetPaymentPlansResponse,
} from "../model"

import { backofficeRequest } from "../../client"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * @summary Retrieve payment plans for a given account
 */
export const getPaymentPlansByAccountId = (
  id: number,
  options?: SecondParameter<typeof backofficeRequest<GetPaymentPlansResponse>>,
) => {
  return backofficeRequest<GetPaymentPlansResponse>(
    { url: `/accounts/${id}/payment-plans`, method: "GET" },
    options,
  )
}
/**
 * @summary Create a payment plan
 */
export const createPaymentPlan = (
  id: number,
  createPaymentPlanRequest: CreatePaymentPlanRequest,
  options?: SecondParameter<typeof backofficeRequest<AccountPaymentPlan>>,
) => {
  return backofficeRequest<AccountPaymentPlan>(
    {
      url: `/accounts/${id}/payment-plans`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createPaymentPlanRequest,
    },
    options,
  )
}
/**
 * @summary Cancel an accounts payment plan
 */
export const cancelPaymentPlan = (
  id: number,
  cancelPaymentPlanRequest: CancelPaymentPlanRequest,
  params?: CancelPaymentPlanParams,
  options?: SecondParameter<typeof backofficeRequest<void>>,
) => {
  return backofficeRequest<void>(
    {
      url: `/accounts/${id}/cancel-payment-plans`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: cancelPaymentPlanRequest,
      params,
    },
    options,
  )
}
/**
 * @summary Retrieve payment plan options for a given account
 */
export const getPaymentPlanOptionsByAccountId = (
  id: number,
  params?: GetPaymentPlanOptionsByAccountIdParams,
  options?: SecondParameter<
    typeof backofficeRequest<GetPaymentPlanOptionsResponse>
  >,
) => {
  return backofficeRequest<GetPaymentPlanOptionsResponse>(
    { url: `/accounts/${id}/payment-plan-options`, method: "GET", params },
    options,
  )
}
export type GetPaymentPlansByAccountIdResult = NonNullable<
  Awaited<ReturnType<typeof getPaymentPlansByAccountId>>
>
export type CreatePaymentPlanResult = NonNullable<
  Awaited<ReturnType<typeof createPaymentPlan>>
>
export type CancelPaymentPlanResult = NonNullable<
  Awaited<ReturnType<typeof cancelPaymentPlan>>
>
export type GetPaymentPlanOptionsByAccountIdResult = NonNullable<
  Awaited<ReturnType<typeof getPaymentPlanOptionsByAccountId>>
>
